/**
 * @generated SignedSource<<e77042855258c5ba3ec78dab5099211f>>
 * @relayHash d83e6d86431f2797956314017c183dc8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f8621d60dedfcc549150249864b2904d1b1dd8bfbe81457bc6fe3cf7212613ce

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdates507BadPatternSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdates507BadPatternSubscription$data = {
  readonly jira: {
    readonly onIssueDeletedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdates507BadPatternSubscription = {
  response: IssueRealtimeUpdates507BadPatternSubscription$data;
  variables: IssueRealtimeUpdates507BadPatternSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueDeletedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueDeletedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdates507BadPatternSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdates507BadPatternSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "f8621d60dedfcc549150249864b2904d1b1dd8bfbe81457bc6fe3cf7212613ce",
    "metadata": {},
    "name": "IssueRealtimeUpdates507BadPatternSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "2cb4bc777c88d9c2f9bae88094edf457";

export default node;
